import { Source } from '@mui/icons-material'
import {
  Avatar,
  Box,
  Button,
  Divider,
  IconButton,
  Typography
} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import React from 'react'
import { connect } from 'react-redux'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import NivosPost from 'types/nivos-post'
import { mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  user: UserPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    user: UserOperations
  }
}

interface OwnProps {
  post: NivosPost
  viewPostFn: (post: NivosPost) => void
}

type AppProps = StateProps & DispatchProps & OwnProps

const PostMiniViewFC: React.FC<any> = (props: AppProps) => {
  const { theme, post, viewPostFn } = props
  const isMobileView = useMediaQuery('(max-width:600px)')

  return (
    <Box
      width={1}
      border={1}
      padding={2}
      borderColor={theme.secondaryColor}
      borderRadius={'12px'}
    >
      <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'}>
        <Avatar src={post.createdBy.image?.url} />
        <Box padding={1} flexGrow={1}>
          <Typography>
            {`${post.createdBy.firstName} ${post.createdBy.lastName}`}
          </Typography>
          <Typography variant={'body2'}>
            {new Date().toLocaleString()}
          </Typography>
        </Box>
        <Box>
          {isMobileView && (
            <IconButton onClick={() => viewPostFn(post)}>
              <Source />
            </IconButton>
          )}
          {!isMobileView && (
            <Button
              variant={'outlined'}
              startIcon={<Source />}
              sx={{ borderRadius: 12 }}
              onClick={() => viewPostFn(post)}
            >
              View Post
            </Button>
          )}
        </Box>
      </Box>
      <Box padding={1}>
        <Typography variant={'h4'}>{post.title}</Typography>
      </Box>
      <Divider />
      <Box padding={1} height={175} overflow={'auto'}>
        <Typography>{post.content}</Typography>
      </Box>
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    user: state.user
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  user: userOperations
})

const PostMiniView = connect(
  mapStateToProps,
  mapDispatchToProps
)(PostMiniViewFC) as React.FC<OwnProps>

export default PostMiniView
